import { setLibraryProgressFn } from "@/actions/community/handler";
import { Button } from "@/components/ui/button";
import { useMutation } from "@tanstack/react-query";
import { Check, Circle } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

export function LibraryProgressButton({
  entryId,
  initialCompleted,
  authenticated,
}: {
  entryId: string;
  initialCompleted: boolean;
  authenticated: boolean;
}) {
  const [completed, setCompleted] = useState(initialCompleted);
  const mutation = useMutation({
    mutationFn: (next: boolean) =>
      setLibraryProgressFn({ data: { entryId, completed: next } }),
    onSuccess: ({ completed: next }) => setCompleted(next),
    onError: () => toast.error("Okuma ilerlemesi kaydedilemedi."),
  });
  return (
    <Button
      type="button"
      variant={completed ? "outline" : "default"}
      disabled={mutation.isPending}
      onClick={() => {
        if (!authenticated) {
          toast.info("İlerlemenizi kaydetmek için giriş yapın.");
          return;
        }
        mutation.mutate(!completed);
      }}
    >
      {completed ? (
        <Check className="mr-2 h-4 w-4" />
      ) : (
        <Circle className="mr-2 h-4 w-4" />
      )}
      {completed ? "Okundu" : "Okundu işaretle"}
    </Button>
  );
}
